import React, { createContext, useContext, useState } from 'react';

export interface ArtifactSummary {
  total: number;
  tasks: number;
  routines: number;
  chats: number;
  uploads: number;
}

export interface ArtifactRecentItem {
  id: string;
  filename: string;
  created_at: string;
  flow: 'tasks' | 'routines' | 'chats';
}

export interface ArtifactVersionItem {
  id: string;
  filename: string;
  created_at: string | null;
  version_number: number;
  routine_run_id: number | null;
  is_latest: boolean;
  app_url: string;
  download_url: string;
}

interface ArtifactsStatsContextValue {
  summary: ArtifactSummary | null;
  recentItems: ArtifactRecentItem[];
  summaryLoading: boolean;
  setSummary: (s: ArtifactSummary | null) => void;
  setRecentItems: (items: ArtifactRecentItem[]) => void;
  setSummaryLoading: (v: boolean) => void;
  activeArtifactId: string | null;
  versions: ArtifactVersionItem[];
  setActiveArtifactId: (id: string | null) => void;
  setVersions: (v: ArtifactVersionItem[]) => void;
}

const ArtifactsStatsContext = createContext<ArtifactsStatsContextValue>({
  summary: null,
  recentItems: [],
  summaryLoading: true,
  setSummary: () => {},
  setRecentItems: () => {},
  setSummaryLoading: () => {},
  activeArtifactId: null,
  versions: [],
  setActiveArtifactId: () => {},
  setVersions: () => {},
});

export const ArtifactsStatsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [summary, setSummary]               = useState<ArtifactSummary | null>(null);
  const [recentItems, setRecentItems]       = useState<ArtifactRecentItem[]>([]);
  const [summaryLoading, setSummaryLoading] = useState(true);
  const [activeArtifactId, setActiveArtifactId] = useState<string | null>(null);
  const [versions, setVersions]             = useState<ArtifactVersionItem[]>([]);
  return (
    <ArtifactsStatsContext.Provider value={{
      summary, recentItems, summaryLoading, setSummary, setRecentItems, setSummaryLoading,
      activeArtifactId, versions, setActiveArtifactId, setVersions,
    }}>
      {children}
    </ArtifactsStatsContext.Provider>
  );
};

export const useArtifactsStats = () => useContext(ArtifactsStatsContext);
